import React from 'react'
import Education from '../Education/Education'
import './About.css'


const About = () => {
    return (
        <>
        <section className='aboutRoot' id='About'>

            <h1 className='aboutMain'>ABOUT</h1>
            <p className='aboutIntro'>
                I am a 4th year computer science student from Government Engineering College Bilaspur.
                <br />
                I am currently working on React.js and Data structure and Algorithms.

            </p>
            
        </section>

        <Education/>
        </>
    )
}

export default About
